import { useCallback, useEffect, useState, useRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import IconPerson from 'components/IconPerson'
import { useLocalStorage } from 'usehooks-ts'
import { HiOutlineArrowNarrowUp } from 'react-icons/hi'
import { Waypoint } from 'react-waypoint'

const EstimatePeople = ({
  tenant,
  colorMode,
  percentage,
  people,
  color,
  title,
  type,
  difference,
  percBev,
  percPar,
  percDiff,
  seats,
  population,
}: {
  tenant?: object
  colorMode: string
  percentage: number
  people?: number
  color?: string
  title: string
  type: string
  difference?: number
  percBev: number
  percPar: number
  percDiff: number
  seats: number
  population?: number
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const [perc, setPerc] = useState(0)
  const [rowHeight, setRowHeight] = useState(25)
  const rowPadding = 3
  const [showDiff, setShowDiff] = useState(false)
  const [userProfile] = useLocalStorage('userProfile', {})
  // console.log('userProfile', userProfile)

  const commatize = (word: any) => {
    const replaced = word.toString().replace('.', ',')
    return replaced.indexOf(',0') > 1 && replaced.slice(-2) === ','
      ? replaced.replace(',0', '')
      : replaced
  }

  const numberWithApostroph = function (x: number) {
    let num = x.toString()
    if (num.length > 4) {
      num = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
    }
    return num
  }

  const adjustRowHeight = (height: number) => {
    if (height + rowPadding !== rowHeight) {
      // console.log('new height:', height, 'old height:', rowHeight)
      setRowHeight(height + rowPadding)
    }
  }

  const showDifferences = function () {
    // console.log('waypoint triggered', title)
    setTimeout(function () {
      // console.log('showDifferences', title)
      setShowDiff(true)
    }, 450)
  }

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
  }

  useEffectOnce(() => {
    if (people) {
      setPerc((people / seats) * 100)
    } else if (percentage) {
      setPerc(percentage)
    } else {
      setPerc(0)
    }
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  const diffRounded = difference ? Math.round(difference) : undefined

  const PeopleCount = people
    ? people
    : percentage
    ? ((seats / 100) * perc) % 1 < 0.1
      ? Math.round((seats / 100) * perc)
      : Math.ceil((seats / 100) * perc)
    : 0

  const arrayCount =
    type === 'parlament'
      ? diffRounded && diffRounded < 0
        ? PeopleCount + -diffRounded
        : PeopleCount
      : PeopleCount

  if (type === 'parlament') {
    /*
    console.log('##', title, '##')
    console.log('people', people)
    console.log('seats', seats)
    console.log('PeopleCount', PeopleCount)
    console.log('arrayCount', arrayCount)
    console.log('difference', difference)
    console.log('diffRounded', diffRounded)
    console.log('percDiff', Math.abs(percDiff))
    */
  } else {
    // console.log('population', population)
  }

  const peopleArr = Array.from(Array(Math.round(arrayCount)).keys()) // create array with max 246 items

  return (
    <Waypoint
      scrollableAncestor={window}
      bottomOffset={isMobile ? '200px' : '100px'}
      onEnter={() => showDifferences()}
    >
      <EstimationWrapper className={type}>
        {type === 'bevoelkerung' &&
          Object.values(userProfile).includes(title) && (
            <div className='selected' />
          )}
        {title && (
          <>
            <h3 lang='de'>
              <span className='percent'>
                {perc !== 0 ? commatize(perc.toFixed(1)) + '%' : '0%'}
              </span>
              <span
                dangerouslySetInnerHTML={{
                  __html: title,
                }}
              />{' '}
            </h3>
            <div className='counter'>
              {type === 'parlament'
                ? PeopleCount + ' von ' + seats
                : population &&
                  commatize(
                    Math.round(
                      (((population / 100) * percentage) / 1000000) *
                        (percentage >= 1 ? 10 : 100)
                    ) / (percentage >= 1 ? 10 : 100)
                  ) +
                    ' Mio. ≈ ' +
                    commatize(Math.round((seats / 100) * perc * 10) / 10) +
                    ' Sitze'}
            </div>
          </>
        )}
        <Estimatepeople
          isMobile={isMobile}
          rowHeight={rowHeight}
          rowPadding={rowPadding}
          arrayCount={arrayCount}
          seats={seats}
        >
          <div className='grid'>
            {peopleArr.map(function (item, index) {
              return (
                <>
                  <IconPerson
                    className={'person pp-' + index}
                    perc={(seats / 100) * perc}
                    dec={index}
                    key={index}
                    color={color}
                    adjustRowHeight={adjustRowHeight}
                    colorMode={colorMode}
                    estimationID={
                      title
                        ?.toLocaleLowerCase()
                        .replace(/ /g, '')
                        .replace("'", '')
                        .replace('(', '')
                        .replace(')', '') +
                      '-' +
                      type.toLocaleLowerCase().replace(/ /g, '')
                    }
                    type={type}
                    difference={diffRounded}
                    total={arrayCount}
                    showDiff={showDiff}
                  />
                </>
              )
            })}
          </div>
          {type === 'bevoelkerung' &&
            Object.values(userProfile).includes(title) && (
              <div className={showDiff ? 'you' : 'you hidden'}>
                <div className='txt-wrap'>
                  <b>Sie</b> sind{' '}
                  {Math.abs(percDiff) < percBev / 10 || Math.abs(percDiff) < 3
                    ? 'gut vertreten'
                    : percDiff < 0
                    ? percPar < percBev / 2
                      ? 'stark untervertreten'
                      : 'untervertreten'
                    : percPar > percBev * 1.5
                    ? 'stark übervertreten'
                    : 'übervertreten'}
                </div>
              </div>
            )}
        </Estimatepeople>
        {type === 'parlament' &&
          diffRounded &&
          !isNaN(diffRounded) &&
          diffRounded !== 0 && (
            <div
              className={
                diffRounded > 0
                  ? showDiff
                    ? 'difference plus'
                    : 'difference plus hidden'
                  : showDiff
                  ? 'difference minus'
                  : 'difference minus hidden'
              }
            >
              {diffRounded < 0
                ? Math.floor(-diffRounded) +
                  (-diffRounded < 2 ? ' Sitz zu wenig' : ' Sitze zu wenig')
                : Math.floor(diffRounded) +
                  (diffRounded < 2 ? ' Sitz zu viel' : ' Sitze zu viel')}
            </div>
          )}
      </EstimationWrapper>
    </Waypoint>
  )
}

const EstimationWrapper = styled.div`
  &.bevoelkerung {
    padding: 0 0 0 1rem;
  }
  &.parlament {
    padding: 0 1rem 0 0;
  }
  position: relative;

  margin-bottom: 2.4rem;
  h3 {
    position: relative;
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 2rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.4rem;
      line-height: 1.9rem;
    }
    text-align: left;
    padding: 0 0 0.25rem;
    border-bottom: 1px solid var(--gray-4);
    margin-bottom: 0.2rem;

    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;

    .percent {
      float: right;
      margin-left: 1rem;
      font-size: 1.4rem;
      font-weight: 600;
      text-align: right;
    }
  }
  .counter {
    font-size: 1.15rem;
    _font-weight: 600;
    text-align: center;
    line-height: 1.9rem;
    margin-bottom: 0.8rem;
  }
  .difference {
    margin: 1.2rem auto 0;
    width: 80%;
    @media only screen and (max-width: 600px) {
      width: 92%;
    }
    background-color: var(--difference-background);
    text-align: center;
    font-size: 1.3rem;
    font-weight: 600;
    &.plus {
      color: var(--red-main);
    }
    &.minus {
      color: var(--red-main);
    }
    &.hidden {
      opacity: 0;
    }
    _transition: opacity 2s;
  }
  .selected {
    position: absolute;
    z-index: -1;
    top: 0.75rem;
    bottom: 3.5rem;
    left: 0;
    right: -1rem;
  }
  .selected,
  .you {
    background-color: var(--selected-background);
  }
  .you {
    left: -1.6rem;
    width: calc(100% + 3.2rem);
    @media only screen and (max-width: 600px) {
      left: -1.2rem;
      width: calc(100% + 2.4rem);
    }
    font-size: 1.3rem;
    line-height: 1.6rem;
    position: relative;
    padding: 1.8rem 0 1rem;
    text-align: center;
    &.hidden {
      opacity: 0;
    }
    _transition: opacity 2s;
    .txt-wrap {
      padding: 0 2rem;
    }
  }
`

const Estimatepeople = styled.div<{
  isMobile: boolean
  rowHeight: number
  rowPadding: number
  arrayCount: number
  seats: number
}>`
  padding: 0 0.6rem;
  @media only screen and (max-width: 600px) {
    padding: 0 0.2rem;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(
      10,
      1fr
    ); // set the number of columns in one row
    column-gap: 2px;
    grid-auto-rows: ${(prop) => prop.rowHeight}px;
  }

  .person {
    position: relative;
    display: block;
  }
`

export default EstimatePeople
